import React, { Component } from 'react';
import './Image.css';

function Image(props) {	
  const { copyright, hdurl, title, url } = props.data;

  return (
    <div className="backg">
      <div>
        <a href={ hdurl } target="_blank">
          <img className='img-fluid' src={ url } alt={ title } />
        </a>
        <p>©{ copyright }</p>
      </div>
    </div>
  )
}

export default Image;